export default __webpack_public_path__ + "img/reward_2-3-f64b24aa.png";